import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AcceptPolicyModal from '../components/modal/AcceptPolicy/AcceptPolicyModal'
import AddResourceModal from '../components/Student/UserCompiledQuest/Resources/AddResourceModal'
import ChangePassword from '../components/modal/ChangePassword/ChangePassword'
import DeleteFocusSkill from '../components/modal/FocusSkills/DeleteFocusSkill'
import DeleteGuidance from '../components/modal/FocusSkills/DeleteGuidance'
import DeleteSkillCheck from '../components/modal/InlineSkillCheck/DeleteSkillCheck'
import DeleteMentorGuidance from '../components/modal/MentorGuidance/DeleteMentorGuidance'
import DeleteResource from '../components/Student/UserCompiledQuest/Resources/DeleteResource'
import DropQuest from '../components/modal/DropQuest'
import EditAvatar from '../components/modal/EditAvatar'
import LevelModal from '../components/MyCourses/Courses/LevelModal/LevelModal'
import LevelModalMentor from '../components/MyCourses/Courses/LevelModal/LevelModalMentor'
import GeneralError from '../components/modal/GeneralError'
import MentorNotes from '../components/modal/MentorNotes'
import SkillsCheck from '../components/modal/SkillsCheck'
import SkillsTrends from '../components/modal/SkillsTrends'
import UpdateTargetDate from '../components/modal/UpdateTargetDate/UpdateTargetDate'
import TargetDateSavingError from '../components/modal/UpdateTargetDate/TargetDateSavingError'
import CloseJourneySections from '../components/modal/CloseJourneySections/CloseJourneySections'
import CloseJourneySectionNotification from '../components/modal/CloseJourneySections/CloseJourneySectionNotification'
import ErrorClosingJourneySection from '../components/modal/CloseJourneySections/ErrorClosingJourneySection'
import DeleteAnnouncement from '../components/modal/Announcements/DeleteAnnouncement'
import EditAnnouncement from '../components/modal/Announcements/EditAnnouncement'
import CreateGuardianModal from '../components/modal/CreateGuardian/CreateGuardianModal'
import GuardianSuccessModal from '../components/modal/CreateGuardian/GuardianSuccessModal'
import GuardianErrorModal from '../components/modal/CreateGuardian/GuardianErrorModal'
import InvalidLinkModal from '../components/modal/CreateGuardian/InvalidLinkModal'
import GuardianEmailAlreadyUsed from '../components/modal/CreateGuardian/GuardianEmailAlreadyUsed'
import LinkGuardianModal from '../components/modal/CreateGuardian/LinkGuardianAccount'
import OurPoliciesModal from '../components/modal/CreateGuardian/OurPoliciesModal'
import QuestPeers from '../components/modal/QuestPeers'
import OverrideCheckinSectionSelect from '../components/modal/ActivityCheckin/OverrideCheckinSectionSelect'

const MODAL_COMPONENTS = {
  ACCEPT_POLICIES: AcceptPolicyModal,
  ADD_RESOURCE_MODAL: AddResourceModal,
  CHANGE_PASSWORD: ChangePassword,
  DELETE_GUIDANCE: DeleteGuidance,
  DELETE_FOCUS_SKILL: DeleteFocusSkill,
  DELETE_SKILL_CHECK: DeleteSkillCheck,
  DELETE_MENTOR_GUIDANCE: DeleteMentorGuidance,
  DELETE_RESOURCE: DeleteResource,
  DROP_QUEST: DropQuest,
  EDIT_AVATAR: EditAvatar,
  LEVEL_MODAL: LevelModal,
  LEVEL_MODAL_MENTOR: LevelModalMentor,
  GENERAL_ERROR: GeneralError,
  MENTOR_NOTES: MentorNotes,
  SKILLS_CHECK: SkillsCheck,
  SKILLS_TRENDS: SkillsTrends,
  UPDATE_TARGET_DATE: UpdateTargetDate,
  TARGET_DATE_SAVING_ERROR: TargetDateSavingError,
  CLOSE_JOURNEY_SECTIONS: CloseJourneySections,
  CLOSE_JOURNEY_SECTION_NOTIFICATION: CloseJourneySectionNotification,
  ERROR_CLOSING_JOURNEY_SECTION: ErrorClosingJourneySection,
  DELETE_ANNOUNCEMENT: DeleteAnnouncement,
  EDIT_ANNOUNCEMENT: EditAnnouncement,
  CREATE_GUARDIAN_ACCOUNT: CreateGuardianModal,
  GUARDIAN_ACCOUNT_SUCCESS: GuardianSuccessModal,
  GUARDIAN_ACCOUNT_ERROR: GuardianErrorModal,
  GUARDIAN_LINK_INVALID: InvalidLinkModal,
  GUARDIAN_EMAIL_IN_USE: GuardianEmailAlreadyUsed,
  GUARDIAN_LINK_ACCOUNT: LinkGuardianModal,
  OUR_POLICIES: OurPoliciesModal,
  OVERRIDE_CHECKIN_SECTION_SELECT: OverrideCheckinSectionSelect,
  QUEST_PEERS: QuestPeers
}

const ModalContainer = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null
  }

  const SpecificModal = MODAL_COMPONENTS[modalType]
  return (
    <div className="qw-global-modal-wrapper">
      <SpecificModal {...modalProps} />
    </div>
  )
}

ModalContainer.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.object
}

export { ModalContainer }
export default connect(state => state._modal)(ModalContainer)
